import { BaseModel } from 'projects/core/src/lib/models/base.model';

const TYPES = {
  preparation: 'Vorbereitung', // @translate
  execution: 'Durchführung',
  rating: 'Bewertung',
  'self-assessment': 'Selbsteinschätzung'
};

export class ExercisepartModel extends BaseModel {

  // columns
  name: string;
  type: string;
  start: number;
  duration: number;

  // client attributes
  status: string = null; // null | running | finished
  ratingStatus: string = null; // null | running | finished
  xPosition: string = null;

  public get type_name(): string {
    return (TYPES[this.type]) ? TYPES[this.type] : '';
  }

  public isRunning(): boolean {
    return this.status === 'running';
  }

  public isFinished(): boolean {
    return this.status === 'finished';
  }

}
